import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface IPopulationBasedFundingViewHeaderProps {
    actionLinkLabel: string;
    patientRegistrationStatusLabel: string;
    onActionClickEvent?: () => void;
    disableActionLink: boolean;
}

function PopulationBasedFundingViewHeader(props: IPopulationBasedFundingViewHeaderProps): JSX.Element {
    const { getText } = useTranslation();
    const { actionLinkLabel, patientRegistrationStatusLabel, onActionClickEvent, disableActionLink } = { ...props };

    const actionLink = (<a onClick={onActionClickEvent}>{actionLinkLabel}</a>);
    return (
        <div className="psingle-column wider centered">
            <div className="block separated">
                {!disableActionLink && (
                    <div className="text-right padding-xxl-right">
                        {actionLink}
                    </div>
                )}
                <div className="patient-enrollment-item">
                    <div className="table-wrapper">
                        <div className="padding-md-left">
                            <span>{getText("PopulationBasedFunding_RegistrationStatusLabel")}: </span>
                            <span className="text-bold margin-md-left">
                                {patientRegistrationStatusLabel}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { PopulationBasedFundingViewHeader };
